/**
 * Adapted version of the `react-select/src/components/Option` component
 * to support `dir` attribute per option.
 */
import React from "react";
import { OptionProps } from "react-select/src/components/Option";
import { hasAndIsNotEmpty } from "../../utils/helpers";
import { ReactSelectOption } from ".";

export interface InputSelectCustomOptionProps
  extends OptionProps<ReactSelectOption> {
  children: React.ReactNode | React.ReactNodeArray;
  isRtl?: boolean;
}

export default function InputSelectCustomOption({
  children,
  className,
  cx,
  data,
  isDisabled,
  isFocused,
  isSelected,
  isRtl,
  innerRef,
  innerProps
}: InputSelectCustomOptionProps) {
  // Use the component's isRtl value, and also check if the option's data object has an explicit `dir` value
  const _dir = hasAndIsNotEmpty(data, "dir") ? data.dir : isRtl ? "rtl" : "";

  return (
    <div
      ref={innerRef}
      dir={_dir}
      className={
        // @ts-ignore This is an issue with the @types/react-select@3.0.4
        cx(
          // We don't support emotion in our project (you could say we're emotionless...),
          // so I'd rather not import it here, which is why the following line is commented out.
          // css(getStyles('option', props)),
          {
            option: true,
            // We don't use BEM in our app but have left in react-select's conventions
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
          },
          className
        ) || undefined
      }
      {...innerProps}
    >
      {children}
    </div>
  );
}
